import { temAcesso } from '@/shared/auth/temAcesso'

const Projetos = () => import('./Projetos.vue')
const Projeto = () => import('./Projeto.vue')
const Etapa = () => import('../etapas/Etapa.vue')

export default {
    path: 'projetos',
    name: 'Sgtec_Gestores_Projetos',
    component: Projetos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('SGTEC-GEST-PRJ-00')) {
            next()
        }
    },
    children: [
        {
            path: ':projetoId',
            name: 'Sgtec_Gestores_Projetos_Detalhar',
            component: Projeto,
            beforeEnter: (to, from, next) => {
                if (temAcesso('SGTEC-GEST-PRJ-01')) {
                    next()
                }
            },
            children: [
                {
                    path: 'etapas/:etapaId',
                    name: 'Sgtec_Gestores_Projetos_Etapa_Detalhar',
                    component: Etapa,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('SGTEC-GEST-ETP-01')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
